import React, { useState, useEffect } from 'react';
import { List, Button, Dimmer } from 'semantic-ui-react';
import { useSelector, useDispatch } from 'react-redux';
import { subscriptionActions } from '../../actions';
import Invoice from './Invoice';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import '../../utils';
import './Subscribe.css';

const PlanCards = props => {
  const { t } = useTranslation();
  const status = useSelector(state => state.subscription.status);

  const baseAmount =
    _.get(props.plans[0], 'currency') === 'IRR' ? _.get(props.plans[0], 'amount') : 5.5;
  const interval = {
    day: t('day'),
    week: t('week'),
    month: t('month'),
    year: t('year'),
  };

  return (
    <Dimmer.Dimmable blurring dimmed={status === 'loading'}>
      <div className="cardsBox">
        {props.plans.map((plan, index) => {
          const monthCount = plan.interval === 'year' ? 12 : plan.intervalCount;
          const daysCount =
            plan.interval === 'year'
              ? 365
              : plan.interval === 'month'
                ? plan.intervalCount * 30
                : plan.intervalCount;
          const monthly =
            plan.currency === 'IRR'
              ? Math.floor(plan.amount / monthCount / 1000) * 1000
              : Math.floor((plan.amount / monthCount) * 100) / 100;
          const daily =
            plan.currency === 'IRR'
              ? Math.floor(plan.amount / daysCount / 1000) * 1000
              : Math.floor((plan.amount / daysCount) * 100) / 100;
          const discount = 100 - Math.floor(((plan.amount / monthCount) * 100) / baseAmount);
          const discountDaily =
            100 - Math.floor(((plan.amount / daysCount) * 100) / (baseAmount / 45));
          const monthlyPrice = plan.currency === 'IRR' ? monthly / 10 : monthly.toFixed(2);
          const dailyPrice = plan.currency === 'IRR' ? daily / 10 : daily.toFixed(2);
          const price = plan.currency === 'IRR' ? plan.amount / 10 : plan.amount.toFixed(2);
          const currency =
            plan.currency === 'IRR' && plan.amount / price === 10 ? 'currencyToman' : plan.currency;
          return (
            <div key={index} className={`subscribeCard plan${plan.order - 1}`}>
              {discount > 0 && (
                <div className="discount">
                  <div className="box">
                    <p>
                      <span className="discountRate">
                        %{plan.currency === 'IRR' && discount.toLocaleString().toPersianDigits()}
                        {plan.currency !== 'IRR' && discountDaily.toLocaleString()}
                      </span>
                      <span>{t('discount')}</span>
                    </p>
                  </div>
                  <img
                    src={require(`../../assets/images/template/subscribeDiscount${plan.order -
                      1}.svg`)}
                  />
                </div>
              )}
              <div className="subscribeHeader">
                {plan.currency === 'IRR' && plan.intervalCount.toString().toPersianDigits()}
                {plan.currency !== 'IRR' && plan.intervalCount.toString()} {interval[plan.interval]}
              </div>
              <div className="subscribeContainer">
                <div className="header">
                  {plan.currency === 'IRR' && price.toLocaleString().toPersianDigits()}
                  {plan.currency !== 'IRR' && price.toLocaleString()}{' '}
                  {plan.currency === 'EUR' ? '€' : t(currency)}
                </div>
                <img
                  src={require(`../../assets/images/template/priceImage${plan.order - 1}.svg`)}
                />
                <div className="monthlyPrice">
                  <span className="price">
                    {plan.currency === 'IRR' && monthlyPrice.toLocaleString().toPersianDigits()}
                    {plan.currency !== 'IRR' && dailyPrice.toLocaleString()}
                  </span>
                  <div className="text">
                    <span className="currency">{t(currency)}</span>
                    <span className="period">
                      {plan.currency === 'IRR' ? t('monthly') : t('daily')}
                    </span>
                  </div>
                </div>
                <div className="description">
                  <List>
                    {plan.attributes &&
                      plan.attributes.map((attribute, index) => {
                        return (
                          <List.Item key={index}>
                            {attribute.status === 0 && <List.Icon color="red" name="cancel" />}
                            {attribute.status === 1 && <List.Icon color="green" name="check" />}
                            <List.Content
                              className={`featureTitle  ${attribute.status === 0 && 'disable'}`}
                            >
                              {attribute.title}
                            </List.Content>
                          </List.Item>
                        );
                      })}
                  </List>
                </div>
                <div className="btnBox">
                  <Button
                    basic
                    className="vButton"
                    fluid
                    disabled={!plan.active}
                    onClick={() => props.onBuyPlan(plan._id)}
                    content={t('buy')}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Dimmer.Dimmable>
  );
};

const Subscribe = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(state => state.authentication.user);
  const subscriptionPlans = useSelector(state => state.subscription.subscriptions);
  const invoice = useSelector(state => state.subscription.invoice);
  const loggedIn = useSelector(state => state.authentication.loggedIn);
  const status = useSelector(state => state.subscription.status);
  const [open, setOpen] = useState(false);
  const language = localStorage.getItem('language') || 'rtl/fa-IR';

  useEffect(() => {
    const currency = language === 'rtl/fa-IR' ? 'IRR' : 'EUR';
    dispatch(subscriptionActions.getListOfSubscriptions(currency));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (invoice) {
      setOpen(true);
    }
  }, [invoice]);

  useEffect(() => {
    if (status === 'paid') {
      dispatch(subscriptionActions.getCurrentSubscription());
      setOpen(false);
      notify();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const notify = () => toast.success(t('subscriptionActive'));

  const buySubscriptionPlan = planId => {
    if (loggedIn) {
      dispatch(subscriptionActions.buySubscription(planId));
    } else {
      history.push('/#home');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const cancelDraft = () => {
    setOpen(false);
    dispatch(subscriptionActions.cancelDraftSubscription());
  };

  const payInvoice = billingInformation => {
    dispatch(subscriptionActions.payInvoice(billingInformation));
  };

  return (
    <div id="subscribe" className={`subscribe ${!props.simple && 'alone'}`}>
      {/* <div className="vidBanner">
        <div className="vid">
          <video
            src={require('../../assets/video/bannerSubscribe.mp4')}
            poster="nice-default.jpg"
            autoPlay
            muted
            loop
          />
        </div>
        <div className="content">
          <span className="title">{t('subscribeTitle')}</span>
          <span className="description">{t('subscribeDescription')}</span>
        </div>
      </div> */}
      <div className="subscribeText">
        <h2>{t('buySubscription')}</h2>
        <p>{t('contents:subscriptionParagraph')}</p>
      </div>

      <PlanCards plans={subscriptionPlans} onBuyPlan={buySubscriptionPlan} />
      {invoice && (
        <Invoice open={open} invoice={invoice} onCancel={cancelDraft} onPay={payInvoice} />
      )}
    </div>
  );
};

PlanCards.propTypes = {
  plans: PropTypes.array,
  onBuyPlan: PropTypes.func,
};

export default Subscribe;
